module.exports = __webpack_public_path__ + "static/img/bg.21b5ac45.png";